import type { CompletionRulesV2 } from '@/types/configurationV2'

const LEVELS = ['product', 'curriculum', 'course', 'module', 'lesson'] as const

export default function CompletionRulesV2Editor({
  rules,
  onChange,
}: {
  rules: CompletionRulesV2
  onChange: (rules: CompletionRulesV2) => void
}) {
  const update = (patch: Partial<CompletionRulesV2>) => onChange({ ...rules, ...patch })

  return (
    <div className="space-y-4 max-w-lg">
      <h3 className="text-sm font-bold">완료 조건</h3>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={rules.enforceSequentialProgress}
          onChange={(e) => update({ enforceSequentialProgress: e.target.checked })}
        />
        순차 진행 강제
      </label>

      <div>
        <div className="text-xs text-gray-500 mb-1">레슨 내 컴포넌트 순서</div>
        {(['sequential', 'flexible'] as const).map((mode) => (
          <label key={mode} className="flex items-center gap-1.5 text-sm">
            <input
              type="radio"
              name="seqMode"
              checked={rules.lessonSequenceMode === mode}
              onChange={() => update({ lessonSequenceMode: mode })}
            />
            {mode === 'sequential' ? '순차 (sequential)' : '자유 (flexible)'}
          </label>
        ))}
      </div>

      <label className="flex items-center gap-2 text-sm">
        <input
          type="checkbox"
          checked={rules.allRequiredMustComplete}
          onChange={(e) => update({ allRequiredMustComplete: e.target.checked })}
        />
        필수 컴포넌트 모두 완료해야 다음 진행
      </label>

      <div>
        <div className="text-xs text-gray-500 mb-2">레벨별 최소 점수 (선택)</div>
        {LEVELS.map((level) => (
          <div key={level} className="flex items-center gap-2 mb-1">
            <span className="text-xs w-20 capitalize">{level}</span>
            <input
              type="number"
              min={0}
              max={100}
              value={rules.levelCompletion?.[level]?.minimumScore ?? ''}
              onChange={(e) => {
                const val = e.target.value ? parseInt(e.target.value) : undefined
                update({
                  levelCompletion: {
                    ...rules.levelCompletion,
                    [level]: val !== undefined ? { minimumScore: val } : undefined,
                  },
                })
              }}
              placeholder="-"
              className="w-16 px-2 py-1 text-xs border border-gray-300 rounded"
            />
            <span className="text-xs text-gray-400">%</span>
          </div>
        ))}
      </div>
    </div>
  )
}
